import { render, staticRenderFns } from "./payView.vue?vue&type=template&id=0bf07a95&scoped=true&"
import script from "./payView.vue?vue&type=script&lang=js&"
export * from "./payView.vue?vue&type=script&lang=js&"
import style0 from "./payView.vue?vue&type=style&index=0&id=0bf07a95&prod&scoped=true&lang=css&"
import style1 from "./payView.vue?vue&type=style&index=1&id=0bf07a95&prod&lang=scss&"
import style2 from "./payView.vue?vue&type=style&index=2&id=0bf07a95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf07a95",
  null
  
)

export default component.exports